import React, { FC, useState } from 'react';

import { useSelector } from 'react-redux';

import { RootState } from '../../../reducers';
import { getUser } from '../../../selectors/user';
import styles from './AdminBar.module.scss';
import { DisplayGrid } from './DisplayGrid';

const IS_LOCAL = process.env.RAZZLE_LOCAL === 'true';

export const AdminBar: FC = () => {
  const user = useSelector(getUser);
  const document = useSelector((state: RootState) => state.main?.document);
  const [showGrid, setShowGrid] = useState(false);

  if (!IS_LOCAL && !user) {
    return null;
  }

  const prismicLink =
    document &&
    `${process.env.RAZZLE_PRISMIC_ENDPOINT.replace('.cdn', '').replace(
      '/api/v2',
      ''
    )}/documents~b=working&c=published&l=fr-fr/${document.id}`;

  return (
    <>
      <div className={styles.adminBar}>
        {user && (
          <div className={styles.profil}>Welcome {user.displayName}</div>
        )}
        <a href="/admin">Espace d&apos;administration</a>
        {prismicLink && (
          <a href={prismicLink} target="_blank">
            Modifier
          </a>
        )}
        {(IS_LOCAL || user?.id < 200) && (
          <button
            onClick={() => {
              setShowGrid(!showGrid);
            }}
          >
            Afficher la grille
          </button>
        )}
        <form action="/logout" method="post" className={styles.menu}>
          <input type="submit" value="Logout" />
        </form>
      </div>
      {showGrid && <DisplayGrid />}
    </>
  );
};
